const LOGO_EP3D = "https://customer-assets.emergentagent.com/job_89a536dc-36dd-4821-ba4f-a6c069ebdb60/artifacts/u7v2hasx_Logotipo.png";

/**
 * PCQ - Plano de Controlo da Qualidade - PDF Print (A4 portrait).
 */
export function openPCQ(qcp) {
  const dateStr = qcp.approved_at ? new Date(qcp.approved_at).toLocaleDateString("pt-PT") : "____ / ____ / ______";
  const tableSection = (title, rows, hasResponsible = true) => `
    <h2>${title}</h2>
    <table>
      <thead><tr>
        <th>Caracteristica</th>
        <th>Metodo</th>
        <th>Frequencia / Amostragem</th>
        <th>Criterio</th>
        ${hasResponsible ? "<th>Responsavel</th>" : ""}
      </tr></thead>
      <tbody>${(rows || []).map(r => `<tr>
        <td>${r.characteristic || ""}</td>
        <td>${r.method || ""}</td>
        <td>${r.frequency || ""}</td>
        <td>${r.criteria || ""}</td>
        ${hasResponsible ? `<td>${r.responsible || ""}</td>` : ""}
      </tr>`).join("") || `<tr><td colspan="${hasResponsible ? 5 : 4}" class="empty">Sem dados</td></tr>`}</tbody>
    </table>`;

  const html = `<!DOCTYPE html>
<html lang="pt">
<head>
<meta charset="utf-8" />
<title>${qcp.code} - PCQ ${qcp.part_code}</title>
<style>
  @page { size: A4 portrait; margin: 12mm; }
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Segoe UI', Arial, sans-serif; color: #0f172a; font-size: 10.5px; padding: 12mm 10mm; }
  h1 { font-size: 18px; color: #1e40af; text-transform: uppercase; letter-spacing: 1px; }
  h2 { background: #0f172a; color: #fff; padding: 5px 10px; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.7px; border-left: 4px solid #facc15; margin-top: 12px; }
  .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 4px solid #1e40af; padding-bottom: 7px; margin-bottom: 10px; }
  .brand-name { font-size: 22px; font-weight: 900; color: #0f172a; letter-spacing: -0.5px; }
  .brand-tag { font-size: 9px; color: #f97316; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; }
  .meta-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0; border: 1px solid #cbd5e1; margin-bottom: 6px; }
  .meta-grid div { padding: 4px 8px; border-bottom: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0; font-size: 10.5px; }
  .meta-grid .lbl { color: #64748b; font-weight: 700; text-transform: uppercase; font-size: 8.5px; }
  table { width: 100%; border-collapse: collapse; margin-top: 3px; font-size: 9.5px; }
  th, td { padding: 4px 6px; border: 1px solid #cbd5e1; text-align: left; vertical-align: top; }
  th { background: #f1f5f9; font-size: 9px; font-weight: 700; text-transform: uppercase; color: #475569; }
  .list { margin: 4px 0; padding-left: 18px; font-size: 10px; }
  .list li { padding: 1px 0; }
  .approval { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 14px; margin-top: 18px; font-size: 11px; }
  .approval .sign { border-top: 1px solid #0f172a; padding-top: 3px; font-weight: 600; }
  .foot { margin-top: 12px; text-align: center; font-size: 9px; color: #64748b; border-top: 1px solid #e2e8f0; padding-top: 4px; }
  .empty { color: #94a3b8; font-style: italic; text-align: center; }
  .print-btn { position: fixed; top: 10px; right: 10px; background: #f97316; color: #fff; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; font-weight: 700; }
  @media print { body { -webkit-print-color-adjust: exact; } .no-print { display: none; } }
</style>
</head>
<body>
<button class="print-btn no-print" onclick="window.print()">🖨️ Imprimir</button>

<div class="header">
  <div style="display:flex; align-items:center; gap:14px;">
    <img src="${LOGO_EP3D}" alt="EP3D" style="height:54px;" />
    <div>
      <div style="font-size:13px;font-weight:800;color:#0f172a;letter-spacing:0.5px;">ENGINEERING PROJECT 3D</div>
      <div style="font-size:9px;color:#64748b;font-weight:600;text-transform:uppercase;letter-spacing:1px;">Engenharia · Plásticos · Qualidade</div>
    </div>
  </div>
  <div style="text-align:right">
    <h1>Plano de Controlo da Qualidade</h1>
    <div style="font-size: 11px; color: #475569; font-weight: 600;">${qcp.part_description || ""}</div>
  </div>
</div>

<div class="meta-grid">
  <div><div class="lbl">Codigo do Documento</div><div><strong>${qcp.code}</strong></div></div>
  <div><div class="lbl">Produto</div><div>${qcp.part_description || ""}</div></div>
  <div><div class="lbl">Referencia</div><div>${qcp.part_code || ""}</div></div>
  <div><div class="lbl">Material</div><div>${qcp.material || ""}</div></div>
  <div><div class="lbl">Cor</div><div>${qcp.color || "______"}</div></div>
  <div><div class="lbl">Processo</div><div>Injeccao de Plasticos</div></div>
  <div><div class="lbl">Maquina</div><div>${qcp.machine_code || ""}</div></div>
  <div><div class="lbl">Cavidades</div><div>${qcp.cavities || ""}</div></div>
  <div><div class="lbl">Revisao</div><div>${qcp.revision || "01"}</div></div>
</div>

${tableSection("1. Rececao da Materia-Prima", qcp.raw_material_reception)}
${tableSection("2. Arranque da Producao", qcp.production_startup)}
${tableSection("3. Controlo Durante Producao", qcp.during_production)}

<h2>4. Criterios de Nao Conformidade</h2>
<div style="font-size:10.5px; padding-top: 3px;">Consideram-se nao conformes as pecas que apresentem:</div>
<ul class="list">${(qcp.nonconformity_criteria || []).map(c => `<li>${c}</li>`).join("") || '<li class="empty">Sem criterios</li>'}</ul>

<h2>5. Accoes Correctivas</h2>
<table>
  <thead><tr><th>Problema</th><th>Possivel Causa</th><th>Accao Correctiva</th></tr></thead>
  <tbody>${(qcp.corrective_actions || []).map(a => `<tr><td>${a.problem||""}</td><td>${a.cause||""}</td><td>${a.action||""}</td></tr>`).join("") || '<tr><td colspan="3" class="empty">Sem dados</td></tr>'}</tbody>
</table>

${tableSection("6. Controlo Final", qcp.final_control)}

<h2>7. Rastreabilidade</h2>
<div style="font-size:10.5px; padding-top: 3px;">Cada caixa produzida devera conter:</div>
<ul class="list">${(qcp.traceability_items || []).map(c => `<li>${c}</li>`).join("") || '<li class="empty">Sem itens</li>'}</ul>

<div class="approval">
  <div>
    <div style="font-size:9px; color:#64748b; text-transform:uppercase; font-weight:700;">Responsavel da Qualidade</div>
    <div class="sign" style="margin-top:12px;">${qcp.approved_by || "______________________"}</div>
  </div>
  <div>
    <div style="font-size:9px; color:#64748b; text-transform:uppercase; font-weight:700;">Data</div>
    <div class="sign" style="margin-top:12px;">${dateStr}</div>
  </div>
  <div>
    <div style="font-size:9px; color:#64748b; text-transform:uppercase; font-weight:700;">Assinatura</div>
    <div class="sign" style="margin-top:12px;">&nbsp;</div>
  </div>
</div>

<div class="foot">
  Documento interno EP3D - Engineering Project 3D, Unipessoal Lda &nbsp;·&nbsp; ${qcp.code} &nbsp;·&nbsp; Revisao ${qcp.revision || "01"}</div>
</body>
</html>`;

  const w = window.open("", "_blank", "width=900,height=1000");
  if (!w) { alert("Bloqueado pelo browser. Permita pop-ups."); return; }
  w.document.write(html);
  w.document.close();
}
